// CAR-4038 / CAR-4086: module-scope guard for PageLayout's once-per-page-load re-read of the
// active center's details (its admin switches live on the persisted centerDetail). PageLayout
// remounts on every authenticated navigation, so this keeps the re-read to one per page load
// per center.
//
// Lives in its own module (not inside PageLayout) for the same reason as centerListBootstrap:
// the sign-out paths must reset it, and importing PageLayout from them would be circular.
//
// Sign-out is an SPA navigation, not a reload, so the guard does not clear itself. signOut()
// resets it; otherwise signing back in to the same center in the same tab skips the re-read
// and centerDetail stays empty until the next tab-focus refresh.
let fetchedFor = null

export const hasFetchedCenterDetail = (ccId) => fetchedFor === ccId

export const markCenterDetailFetched = (ccId) => {
  fetchedFor = ccId
}

export const resetCenterDetailFetchGuard = () => {
  fetchedFor = null
}
